import { useCallRecordingQuery } from '../queries/calls';
import { SectionText } from './DrawerParts';

// Provider recordings are often streamed without a Content-Length, so the browser
// reports duration === Infinity and the player shows 0:00 / 0:00. Seeking past the
// end forces it to read the real duration, then we rewind to the start.
export function fixDuration(e) {
  const el = e.currentTarget;
  if (el.duration !== Infinity) return;
  el.currentTime = 1e101;
  const onUpdate = () => {
    el.removeEventListener('timeupdate', onUpdate);
    el.currentTime = 0;
  };
  el.addEventListener('timeupdate', onUpdate);
}

export default function CallRecording({ callId }) {
  const { data, isLoading, isError } = useCallRecordingQuery(callId);

  if (isLoading) return <SectionText>Loading recording…</SectionText>;
  if (isError || !data?.url) return <SectionText>Recording unavailable</SectionText>;
  return (
    <audio
      controls
      preload="metadata"
      src={data.url}
      style={{ width: '100%' }}
      aria-label="Call recording"
      onLoadedMetadata={fixDuration}
    />
  );
}
